/* TDHQ ARTICLE ACTIONS — Share, Copy link, Print guide (article brief 75, 76
   and 86). No social SDK and no library: the browser's own share sheet where
   the device has one, three ordinary links where it does not, the clipboard API
   with a textarea fallback, and window.print for the printed guide.

   The row is delivered with the hidden attribute set and revealed here. That is
   what keeps the page honest without JavaScript — none of these three controls
   can do anything without this file, and without it the guide still reads in
   full and the browser's own print command still works (brief 87).

   The copy and print buttons carry data-tdhq-event, so the site-wide click
   listener in tdhq-header.js reports advice_article_copy_link and
   advice_article_print. It sends the method, a short label and the path only.
   The share links carry no event: brief 98 does not list one. */
(function () {
  var root = document.querySelector('[data-tdhq-artact]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var status = root.querySelector('.tdhq-artact__status');

  /* Writing the same string into a live region twice is silent, and copying the
     same link twice is exactly what a reader does when the first attempt went
     unnoticed. Clearing first makes the second copy announce. */
  function say(message) {
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 60);
  }

  /* execCommand is deprecated, but it is the only path left on a browser
     without the clipboard API, or wherever the page is not a secure context. */
  function legacyCopy(text) {
    try {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.top = '-1000px';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var copied = document.execCommand('copy');
      document.body.removeChild(field);
      return copied;
    } catch (err) {
      return false;
    }
  }

  var shareBtn = root.querySelector('[data-artact-share]');
  var menu = root.querySelector('.tdhq-artact__menu');
  var shareWrap = root.querySelector('.tdhq-artact__sharewrap');

  if (shareBtn && menu && shareWrap) {
    var nativeShare = !!(navigator && navigator.share);
    if (nativeShare) {
      /* The sheet belongs to the browser, so the button must not announce that
         it controls a list of links that will never be opened. */
      shareBtn.removeAttribute('aria-controls');
      shareBtn.removeAttribute('aria-expanded');
    }

    var closeMenu = function (returnFocus) {
      menu.hidden = true;
      shareBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) shareBtn.focus();
    };

    shareBtn.addEventListener('click', function () {
      if (nativeShare) {
        try {
          var sharing = navigator.share({ title: document.title, url: window.location.href });
          /* A share the reader cancels rejects. That is not a failure to report. */
          if (sharing && sharing.catch) sharing.catch(function () {});
        } catch (err) { /* nothing to recover from */ }
        return;
      }
      if (menu.hidden) {
        menu.hidden = false;
        shareBtn.setAttribute('aria-expanded', 'true');
        var first = menu.querySelector('a');
        if (first) first.focus();
      } else {
        closeMenu(false);
      }
    });

    menu.addEventListener('click', function () { closeMenu(false); });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !shareWrap.contains(event.target)) closeMenu(false);
    });
    document.addEventListener('keydown', function (event) {
      if (!menu.hidden && (event.key === 'Escape' || event.key === 'Esc')) closeMenu(true);
    });
  }

  var copyBtn = root.querySelector('[data-artact-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var href = window.location.href;
      var fallback = function () {
        say(legacyCopy(href) ? 'Link copied' : 'The link could not be copied.');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(href).then(function () { say('Link copied'); }, fallback);
        return;
      }
      fallback();
    });
  }

  var printBtn = root.querySelector('[data-artact-print]');
  if (printBtn) {
    printBtn.addEventListener('click', function () { window.print(); });
  }

  root.hidden = false;
})();
